"use client"
import React, { useState, useEffect } from "react";
import Header from "@/components/shared/Header";

import FlashMessages from "@/components/shared/FlashMessages";
import { useRouter } from "next/navigation";
import useApi from "@/components/api/useApi";
import PostViewContainer from "@/components/posts/PostViewContainer";
import { useTenant } from "@/lib/providers/TenantProvider";

const PostViewPage = props => {
  const router = useRouter();
  const { profile, community } = useTenant();
  const [post, setPost] = useState(null);
  const [authentication, setAuthentication] = useState(null);
  const [notFound, setNotFound] = useState(false);
  const [loaded, setLoaded] = useState(false);

  const api = useApi();

  useEffect(() => {
    const profileName = props.match.params.name;
    const postId = props.match.params.pinId;

    if (postId != null) {
      api
        .getPost(profileName, postId)
        .then(thePost => {
          setPost(thePost);
          setLoaded(true);
        })
        .catch(error => {
          setNotFound(true);
        });
    } else {
      setLoaded(true); // NEW POST
    }
  }, [loaded]);

  useEffect(() => {
    if (notFound) router.replace("not-found");
  }, [notFound, router]);

  if (notFound) {
    return null;
  } else if (!loaded) {
    return <></>;
  } else {
    const name = props.match.params.name;
    return (
      <div className="sticky-map">
        <Header name={name} selected="pins" />
        <FlashMessages messages={[]} />
        <PostViewContainer
          name={name}
          profile={profile}
          community={community}
          post={post}
          authentication={authentication}
        />
      </div>
    );
  }
};
export default PostViewPage;
